export default class QueryRelationItem
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryRelationItem";

	tableId;	//String
	fieldId;	//String
	fieldName;	//String
	fieldValue;	//String
		
	relatedTableId;	//String
	relatedFieldId;	//String
	relatedFieldName;	//String
	relatedFieldType;	//String
	relatedEnumClass;	//String
	relatedFieldValue;	//String
		
	fieldType;	//String	//QueryWhereFieldType
	dataField;	//String
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryRelationItem.js